export default (node) => {
  const animationBg = node;
  const span = animationBg?.querySelector('span');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          if (span) {
            span.style.animationPlayState = 'running';
          }
        } else {
          entry.target.classList.remove('visible');
          if (span) {
            span.style.animationPlayState = 'paused';
          }
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px',
    }
  );

  if (animationBg) {
    observer.observe(animationBg);
  }
};
